import * as i0 from "@angular/core";
export class DiscardChangesGuard {
    canDeactivate(component) {
        return component.isSafeToNavigate
            ? component.isSafeToNavigate
            : component.promptDeactivate();
    }
}
DiscardChangesGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DiscardChangesGuard_Factory() { return new DiscardChangesGuard(); }, token: DiscardChangesGuard, providedIn: "root" });
